import { render } from "./FleetFuelDetail.vue?vue&type=template&id=bc06e1f4&scoped=true"
import script from "./FleetFuelDetail.vue?vue&type=script&lang=js"
export * from "./FleetFuelDetail.vue?vue&type=script&lang=js"

import "./FleetFuelDetail.vue?vue&type=style&index=0&id=bc06e1f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc06e1f4"]])

export default __exports__